import { __assign, __rest } from "tslib";
import * as React from 'react';
import { toggleAccordionEvent } from './constants';
function toggleAccordion(ev) {
    var parent = ev.currentTarget.parentElement.parentElement;
    var detail = {
        index: Array.from(parent.parentElement.children).indexOf(parent),
    };
    ev.currentTarget.dispatchEvent(new CustomEvent(toggleAccordionEvent, { bubbles: true, detail: detail }));
}
/**
 * Represents an accordion item.
 */
export var AccordionItem = function (_a) {
    var title = _a.title, children = _a.children, props = __rest(_a, ["title", "children"]);
    return (React.createElement("div", __assign({}, props, { className: "accordion-item-container" }),
        React.createElement("h5", { onClick: toggleAccordion },
            title,
            " ",
            React.createElement("span", { className: "accordion-item-icon" })),
        React.createElement("div", { className: "accordion-item-content" }, children)));
};
//# sourceMappingURL=AccordionItem.js.map